/* src/modules/course_approvals/action.js */

import {
  fetchCourseApprovalTutorsTypes,
  updateCourseApprovalTypes,
  addCoursesToTutorTypes,
  SELECT_COURSE_APPROVAL_TUTOR,
  SELECT_COURSE_APPROVAL_TUTOR_UNIVERSITY,
} from './action_types';

import { makeQuery, makeMutation } from '../../config/client';
import {
  FETCH_COURSE_APPROVAL_TUTORS_QUERY,
  UPDATE_COURSE_APPROVAL_MUTATION,
  ADD_COURSES_TO_TUTOR_MUTATION,
} from './api';

export const fetchCourseApprovalTutors = variables => makeQuery(variables)(
  fetchCourseApprovalTutorsTypes,
  FETCH_COURSE_APPROVAL_TUTORS_QUERY
);

export const updateCourseApproval = variables => makeMutation({ variables })(
  updateCourseApprovalTypes,
  UPDATE_COURSE_APPROVAL_MUTATION
);

export const addCoursesToTutor = variables => makeMutation({ variables })(
  addCoursesToTutorTypes,
  ADD_COURSES_TO_TUTOR_MUTATION
);

export const selectCourseApprovalTutor = payload => ({
  type: SELECT_COURSE_APPROVAL_TUTOR,
  payload,
});

export const selectCourseApprovalTutorUniversity = payload => ({
  type: SELECT_COURSE_APPROVAL_TUTOR_UNIVERSITY,
  payload,
});



// WEBPACK FOOTER //
// ./src/modules/course_approvals/actions.js